import { UserContext } from "context";
import { useContext, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";


const PublicRoute = ({ element }) => {
  const navigate = useNavigate();

  const { token } = useContext(UserContext)
  let isAuthenticated = token

  useEffect(() => {
    if (!isAuthenticated) {
      // navigate("/");
    }
  }, [navigate, token, isAuthenticated])

  return !isAuthenticated ? element : <Navigate to="/dashboard" />;
};

export default PublicRoute
